import axios from 'axios'
import { Message } from 'element-ui'
import { getLang } from '@/utils/storage'
import loginSDK from '@/utils/base.js'
import I18n from '@/i18n/i18n'

let pending = [] //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let cancelToken = axios.CancelToken
let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].u === config.url + '&' + config.method) {
      //当当前请求在数组中存在时执行函数体
      pending[p].f() //执行取消操作
      pending.splice(p, 1) //把这条记录从数组中移除
    }
  }
}

const instance = axios.create({
  timeout: 10000,
  baseURL: process.env.VUE_APP_BASE_URL,
})

// gateway 网关前缀
const prefix = () => {
  return new Map([
    [
      /^\/(organization|event|session|(table\/switch)|record|poll|sponsor|people|bookmark)/,
      '/web/creation',
    ],
  ])
}
const setPrefix = (url) => {
  let _prefix = [...prefix()].filter(([key]) => key.test(url))
  return (_prefix.map(([key, value]) => value + url))[0] || url
}

const getCreatorUrl = () => process.env.VUE_APP_CREATOR_URL
const getSagaUrl = () => process.env.VUE_APP_SAGA_URL
const getUserUrl = () => process.env.VUE_APP_AUTH_URI
const getGatewayUrl = () => process.env.VUE_APP_API_GATEWAY

const actions = () => {
  return new Map([
    [/^\/((event\/detail))/, getCreatorUrl],
    [/^\/((api\/graph)|(api\/event))/, getSagaUrl],
    [/^\/(web)/, getGatewayUrl],
  ])
}
const getBaseUrl = (url) => {
  let action = [...actions()].filter(([key]) => key.test(url))
  return action.map(([key, value]) => value.call(this))[0] || ''
}

instance.interceptors.request.use(
  (config) => {
    config.url = setPrefix(config.url)
    config.baseURL = getBaseUrl(config.url)
    config.headers['X-Ca-Nonce'] = Math.random().toString(36).substr(2, 15)
    config.headers['X-Ca-Timestamp'] = +new Date()
    // config.headers['Date'] = (new Date()).toUTCString();
    config.headers['Method'] = config.method
    config.headers['X-I18n-Language'] = { en: 'en-US', cn: 'zh-CN' }[getLang()]
    if (!config.headers.Authorization) {
      config.headers.Authorization = `${loginSDK.getCurrentToken()}`
    }
    removePending(config) //在一个ajax发送前执行一下取消操作
    config.cancelToken = new cancelToken((c) => {
      // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
      pending.push({ u: config.url + '&' + config.method, f: c })
    })
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  (response) => {
    //在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除
    removePending(response.config)
    const res = response.data
    if (res.code !== 0 && res.code !== 50) {
      // 验证码接口、微信绑定不提示
      Message.error(res.message)
    }
    if (res.code === 0 ) {
      return res
    }
    return Promise.reject(res)
  },
  (error) => {
    //置空请求列表
    if (error.response) {
      switch (error.response.status) {
        case 400: // 请求参数有误
          break
        case 401: // 未登录
          // 重新登录
          window.location.href = '/'
          break
        case 402: // 待确定
          break
        case 403: // 无权限
          break
        case 404: // Not Found
          console.log('404')
          break
        case 405:
          console.log('405')
          break
        case 500: // 服务器内部错误 未知错误
          break
        case 501:
          break
        case 502: //
          break
        default:
          break
      }
      return Promise.reject(error)
    } else {
      if (!window.navigator.onLine) {
        console.log('断网处理')
        Message.error(I18n.t('login.register.offLine'))
        return
      }
      // 异步校验取消请求时有不合规的信息提示，因此使用console错误显示
      console.error(error)
      return Promise.reject()
    }
  }
)

export default instance
